import React, { Component } from 'react';
import FormattedValue from '../../../../FormattedValue/FormattedValue';
import { TableFormattedCell } from './MetricsTableFormattedCell.styled';

interface ITableFormattedCellProps {
   value: number;
   type: string;
   scale: string;
   precision: string;
   showData: boolean;
   level: string;
}
export default class MetricsTableFormattedCell extends Component<ITableFormattedCellProps, {}> {
   public render() {
      const { value, type, scale, precision, showData, level } = this.props;
      return (
         <TableFormattedCell level={level}>
            {showData ? <FormattedValue value={value} type={type} scale={scale} precision={precision} /> : ''}
         </TableFormattedCell>
      );
   }
}
